/* ZCT_V22_SHOP (E3): Filter und Sortierung der Shop-Liste wie Shop() in v21 (JS-022).
   Gleiche Regeln: SEO-Kollektion (ids, tone, exclude), Kategorie bzw. „Neu“, Oberfläche, Preis 0 bis 7000 (Schritt 100,
   Abstand 100, Schnellknöpfe), Sortierung Kuratiert / Bestseller (Reihenfolge aus /collections/all/products.json?sort_by=
   best-selling) / Neu zuerst / Preis auf- und absteigend. Neu gezeichnet ohne Übergang, wie v21. Kopf (Eyebrow, H1, Text),
   Reiter und Filter-Panel folgen dem Zustand wie in v21. Karten werden nur umgehängt (Bilder bleiben geladen). */
(function () {
  'use strict';
  function texte() { var el = document.getElementById('zct-texte'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  var T = texte();
  function ent(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function tx(k) { return T[k] != null ? ent(T[k]) : k; }
  // Preisregler in der Seitensprache (Tausender immer gruppiert, auch es/it)
  function euro(n) { try { return Number(n).toLocaleString(tx('v25_intl_zahl'), { useGrouping: 'always' }) + ' €'; } catch (e) { return n + ' €'; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function katText(c) { return c === 'Neu' ? tx('shop_neu') : c === 'Alle' ? tx('shop_alle') : tx('kategorie_' + c.toLowerCase()); }

  class ZctShop extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var produkte = (window.zctLaden && window.zctLaden.produkte) || [];
      var seo = this.getAttribute('data-seo') || '';
      var seoArt = this.getAttribute('data-seo-art') || '';
      var seoWerte = (this.getAttribute('data-seo-werte') || '').split(',').filter(Boolean);
      var h1Fest = this.getAttribute('data-h1-fest') === '1';
      var textFest = this.getAttribute('data-text-fest') === '1';
      var basisKategorie = this.getAttribute('data-cat') || 'Alle';
      var st = { cat: basisKategorie, toene: [], preis: [0, 7000], sort: 'curated', offen: false, bestOrder: null };

      var crumb = this.querySelector('.crumb');
      var eyebrow = this.querySelector('.col-hero > .eyebrow');
      var h1 = this.querySelector('.col-hero > h1');
      var p = this.querySelector('.col-hero > p');
      var pillen = Array.prototype.slice.call(this.querySelectorAll('[data-zct-pille]'));
      var toggle = this.querySelector('.filter-toggle');
      var select = this.querySelector('.col-head select');
      var overlay = this.querySelector('.filter-overlay');
      var body = this.querySelector('.col-body');
      var aside = this.querySelector('aside.filters');
      var tonBoxen = Array.prototype.slice.call(this.querySelectorAll('[data-zct-ton]'));
      var typBoxen = Array.prototype.slice.call(this.querySelectorAll('[data-zct-typ]'));
      var regler = this.querySelectorAll('.pricerange input[type="range"]');
      var vals = this.querySelectorAll('.pricerange .vals span');
      var fill = this.querySelector('.pricerange .fill');
      var bereiche = Array.prototype.slice.call(this.querySelectorAll('[data-zct-bereich]'));
      var grid = this.querySelector('.col-grid');
      var wrap = this.querySelector('.col-grid-wrap');
      var vorlage = this.querySelector('template[data-zct-shop-weitere]');

      // Karten nach Produkt-ID (sichtbare und die aus der Vorlage)
      var karten = {};
      function merke(card) { var b = card.querySelector('[data-zct-merken]'); if (b) karten[b.getAttribute('data-zct-merken')] = card; }
      Array.prototype.forEach.call(grid.children, merke);
      if (vorlage) Array.prototype.forEach.call(vorlage.content.children, function (c) { merke(document.importNode(c, true)); });
      // Ende-Bereich: Auftragsarbeit oder „Keine Objekte …“
      var auftragBlock = null, leerBlock = null;
      Array.prototype.forEach.call(wrap.children, function (el) {
        if (el === grid) return;
        if (el.querySelector('.co-wrap')) auftragBlock = el; else leerBlock = el;
      });
      // In v21 wird das Formular neu aufgebaut, wenn der Block nach „keine Objekte“ wieder erscheint (Zustand leer)
      var auftragVorlage = auftragBlock ? auftragBlock.cloneNode(true) : null;
      function leer() {
        if (!leerBlock) { leerBlock = document.createElement('div'); leerBlock.setAttribute('style', 'padding: 80px 0px; text-align: center; color: var(--ink-3);'); leerBlock.textContent = tx('shop_keine'); }
        return leerBlock;
      }

      function liste() {
        var items = produkte.slice();
        if (seo) {
          if (seoArt === 'ids') items = items.filter(function (x) { return seoWerte.indexOf(x.id) >= 0; });
          else if (seoArt === 'tone') items = items.filter(function (x) { return (x.toene || []).indexOf(seoWerte[0]) >= 0; });
          else items = items.filter(function (x) { return seoWerte.indexOf(x.id) < 0; });
        }
        if (st.cat !== 'Alle' && st.cat !== 'Neu') items = items.filter(function (x) { return x.kat === st.cat; });
        if (st.cat === 'Neu') items = items.filter(function (x) { return x.flag === 'new'; });
        if (st.toene.length) items = items.filter(function (x) { return (x.toene || []).some(function (t) { return st.toene.indexOf(t) >= 0; }); });
        items = items.filter(function (x) { return x.preis == null || (x.preis / 100 >= st.preis[0] && x.preis / 100 <= st.preis[1]); });
        if (st.sort === 'bestseller' && st.bestOrder) {
          items.sort(function (a, b) { var ai = st.bestOrder.indexOf(a.handle || a.id), bi = st.bestOrder.indexOf(b.handle || b.id); return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi); });
        }
        if (st.sort === 'price-asc') items.sort(function (a, b) { return (a.preis || 0) - (b.preis || 0); });
        if (st.sort === 'price-desc') items.sort(function (a, b) { return (b.preis || 0) - (a.preis || 0); });
        if (st.sort === 'new') items.sort(function (a, b) { return (b.flag === 'new' ? 1 : 0) - (a.flag === 'new' ? 1 : 0); });
        if (st.sort === 'curated') items.sort(function (a, b) { return a.rang - b.rang; });
        return items;
      }

      function zeichnen() {
        // Kopf
        var titel = st.cat === 'Alle' ? tx('shop_produkte') : katText(st.cat);
        crumb.innerHTML = crumb.innerHTML.replace(/(<span>\/<\/span>[^<]*<span>\/<\/span>).*$/, '$1' + esc(titel));
        eyebrow.textContent = seo ? tx('shop_kollektion') : st.cat === 'Alle' ? tx('shop_alle_kategorien') : katText(st.cat);
        if (!h1Fest) h1.innerHTML = st.cat === 'Alle' ? esc(tx('shop_die')) + ' <span class="accent-word">' + esc(tx('shop_kollektion_punkt')) + '</span>' : esc(tx('shop_entdecke')) + ' <span class="accent-word">' + esc(katText(st.cat)) + '.</span>';
        if (!textFest && p) p.textContent = st.cat === 'Alle' ? tx('shop_text_alle') : tx('shop_text_kategorie');
        pillen.forEach(function (a) { var c = a.getAttribute('data-zct-pille'); var on = st.cat === c && !(c === 'Alle' && seo); a.className = on ? 'on' : ''; });
        // Filter-Panel
        var aktiv = st.toene.length > 0 || st.preis[0] > 0 || st.preis[1] < 7000;
        toggle.className = 'filter-toggle ' + (st.offen ? 'on' : '');
        toggle.setAttribute('aria-expanded', String(st.offen));
        toggle.innerHTML = esc(tx('v25_filter')) + (aktiv ? '<span class="dot-active"></span>' : '') + '<span class="chev">' + (st.offen ? '−' : '+') + '</span>';
        overlay.className = 'filter-overlay' + (st.offen ? ' open' : '');
        body.className = 'col-body' + (st.offen ? '' : ' no-filters');
        aside.className = 'filters' + (st.offen ? ' open' : '');
        select.value = st.sort;
        tonBoxen.forEach(function (b) { b.checked = st.toene.indexOf(b.getAttribute('data-zct-ton')) >= 0; });
        typBoxen.forEach(function (b) { b.checked = st.cat === b.getAttribute('data-zct-typ'); });
        regler[0].value = st.preis[0]; regler[1].value = st.preis[1];
        vals[0].textContent = euro(st.preis[0]);
        vals[1].textContent = euro(st.preis[1]) + (st.preis[1] >= 7000 ? '+' : '');
        fill.style.left = (st.preis[0] / 7000 * 100) + '%';
        fill.style.right = (100 - st.preis[1] / 7000 * 100) + '%';
        bereiche.forEach(function (b) {
          var g = b.getAttribute('data-zct-bereich').split('-').map(Number);
          var an = st.preis[0] === g[0] && st.preis[1] === g[1];
          b.style.background = an ? 'var(--ink)' : 'var(--paper)';
          b.style.color = an ? 'var(--paper)' : 'var(--ink)';
        });
        // Karten
        var items = liste();
        var neu = items.map(function (x) { return karten[x.id]; }).filter(Boolean);
        var gleich = neu.length === grid.children.length && neu.every(function (c, i) { return grid.children[i] === c; });
        if (!gleich) grid.replaceChildren.apply(grid, neu);
        var merk = (window.zctLaden && window.zctLaden.wish()) || [];
        neu.forEach(function (c) { var b = c.querySelector('[data-zct-merken]'); if (b) b.className = 'wish ' + (merk.indexOf(b.getAttribute('data-zct-merken')) >= 0 ? 'on' : ''); });
        if (neu.length === 0) { if (auftragBlock && auftragBlock.isConnected) auftragBlock.remove(); if (!leer().isConnected) wrap.appendChild(leer()); }
        else {
          if (leerBlock && leerBlock.isConnected) leerBlock.remove();
          if (auftragBlock && !auftragBlock.isConnected) {
            auftragBlock = auftragVorlage.cloneNode(true);
            wrap.appendChild(auftragBlock);
            if (window.zctAuftragStart) window.zctAuftragStart();
          }
        }
      }

      toggle.addEventListener('click', function () { st.offen = !st.offen; zeichnen(); });
      overlay.addEventListener('click', function () { st.offen = false; zeichnen(); });
      this.querySelector('[data-zct-filter-zu]').addEventListener('click', function () { st.offen = false; zeichnen(); });
      select.addEventListener('change', function () { st.sort = select.value; zeichnen(); });
      tonBoxen.forEach(function (b) { b.addEventListener('change', function () { var k = b.getAttribute('data-zct-ton'); st.toene = st.toene.indexOf(k) >= 0 ? st.toene.filter(function (x) { return x !== k; }) : st.toene.concat([k]); zeichnen(); }); });
      typBoxen.forEach(function (b) { b.addEventListener('change', function () { var c = b.getAttribute('data-zct-typ'); st.cat = st.cat === c ? 'Alle' : c; zeichnen(); }); });
      regler[0].addEventListener('input', function () { st.preis = [Math.min(+regler[0].value, st.preis[1] - 100), st.preis[1]]; zeichnen(); });
      regler[1].addEventListener('input', function () { st.preis = [st.preis[0], Math.max(+regler[1].value, st.preis[0] + 100)]; zeichnen(); });
      bereiche.forEach(function (b) { b.addEventListener('click', function () { st.preis = b.getAttribute('data-zct-bereich').split('-').map(Number); zeichnen(); }); });
      this.querySelector('[data-zct-filter-reset]').addEventListener('click', function () { st.toene = []; st.preis = [0, 7000]; st.cat = basisKategorie; zeichnen(); });

      // Startzustand wie v21 erzwingen (der Browser stellt beim Zurückgehen sonst alte Formularwerte her)
      zeichnen();

      fetch('/collections/all/products.json?sort_by=best-selling&limit=250').then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.products) { st.bestOrder = d.products.map(function (x) { return x.handle; }); if (st.sort === 'bestseller') zeichnen(); }
      }).catch(function () {});
    }
  }
  if (!customElements.get('zct-shop')) customElements.define('zct-shop', ZctShop);
})();
